<template>
  <v-dialog
    v-model="new_queue_dialog"
    class="template-pop-up template-pop-up-fix"
    max-width="600px">
    <EditQueueModalv2
      :go_to_tab="tab"
      :current_channel="channel_did"
      v-if="new_queue_dialog && current_queue"
      :current_queue="current_queue"
      v-on:close="new_queue_dialog = false" />
  </v-dialog>
  <v-dialog
    v-model="edit_scene_dialog"
    class="template-pop-up"
    max-width="600px">
    <EditSceneModalv2
      :go_to_tab="tab"
      v-if="edit_scene_dialog && deluge && current_scene"
      :current_channel="channel_did"
      :current_scene="current_scene"
      v-on:close="edit_scene_dialog = false" />
  </v-dialog>
  <draggable
    style="background: var(--v-backgroundOffWhite-base); border-radius: 6px"
    :move="scene_move"
    :disabled="!state.channelOnAirEditMode && !editMode"
    @choose="start_scene_drag($event, queue)"
    @start="start_scene_drag($event, queue)"
    @end="end_scene_drag($event)"
    @click="handleClick"
    :animation="150"
    :group="{
      animation: 150,
      group: 'scenes',
      put: true,
      pull: true,
      direction: 'horizontal',
      dragoverBubble: true,
    }"
    class="list-group queue_group draggablearea drag-parent-container"
    id="drag-parent-container"
    handle=".grabber"
    @change="moved_in_queue($event, queue)"
    :list="queue.items"
    item-key="did">
    <template
      #item="{ element, index }"
      style="flex: 0 0 0px">
      <v-lazy
        min-height="92"
        min-width="220"
        v-if="element.type === 'queue' && element.did in deluge.items">
        <QueueCard
          :editMode="editMode"
          :scene_index="index"
          :queue="deluge.items[element.did]"
          v-on:OpenPlayConditions="OpenQueueModal(deluge.items[element.did], 1)"
          v-on:OpenTriggers="OpenQueueModal(deluge.items[element.did], 2)"
          v-on:OpenSettings="OpenQueueModal(deluge.items[element.did], 0)"
          v-on:OpenQueue="
            OpenQueue(get_master_queue(deluge.items[queue.did]), index)
          "
          class="mt-1"
          style="margin-left: auto; margin-right: auto"
          :scene="element"
          :channel_did="channel_did"
          :current="index === queue.index"
          v-if="deluge.items[element.did]" />
      </v-lazy>
      <v-lazy
        min-height="92"
        min-width="230"
        v-else-if="deluge.items[element.did]">
        <SceneCard
          :editMode="editMode"
          :scene_index="index"
          :current="index === queue.index"
          :queue="deluge.items[queue.did]"
          v-on:OpenSettings="OpenSceneModal(deluge.items[element.did], 0)"
          v-on:OpenPlayConditions="OpenSceneModal(deluge.items[element.did], 2)"
          v-on:OpenTriggers="OpenSceneModal(deluge.items[element.did], 3)"
          class="mt-1"
          style="margin-left: auto; margin-right: auto"
          :scene="element"
          :channel_did="channel_did" />
      </v-lazy>
    </template>
  </draggable>
</template>
<script setup>
import SceneCard from './SceneCard.vue';
import { defineProps, ref, watch } from 'vue';
import { state } from '../../stores/deluge.js';
import draggable from 'vuedraggable';
import { $http } from '../../stores/http.js';
import QueueCard from './QueueCard.vue';
import EditQueueModalv2 from './EditQueueModalv2.vue';
import EditSceneModalv2 from './EditSceneModalv2.vue';
import { deluge } from '@/stores/deluge.js';
const ctrl_down = ref(false);
const shift_down = ref(false);

watch(
  () => state.ctrl_down,
  (newVal) => {
    ctrl_down.value = newVal;
  }
);
watch(
  () => state.shift_down,
  (newVal) => {
    shift_down.value = newVal;
  }
);
const emit = defineEmits(['clear_mini', 'openqueue']);
const edit_scene_dialog = ref(false);
const props = defineProps(['queue', 'channel_did', 'j', 'editMode']);
const current_queue = ref(undefined);
const new_queue_dialog = ref(false);
const tab = ref(0);
const current_scene = ref(null);

async function cloneScene(scenedDidToClone, index, pdid) {
  let queueToAddTo = null;
  if (pdid) {
    queueToAddTo = deluge.items[pdid].id;
  } else {
    queueToAddTo = deluge.items[deluge.items[scenedDidToClone].pdid].id;
  }
  try {
    const response = await $http(
      'POST',
      `/dynamic_engine/scene_from_scene?qid=${queueToAddTo}&scene_id=${scenedDidToClone}&update_deluge=true&index=${index}`
    );
  } catch (error) {
    console.log(error);
  }
  emit('close', true);
}

async function cloneQueue(
  channelDID,
  queueDID,
  indexToCloneInto = undefined,
  queueToCloneInto = undefined
) {
  const queueUid = deluge.items[queueDID].uid;
  try {
    const response = await $http(
      'POST',
      '/dynamic_engine/queue_from_queue?queue_uid=' +
        queueUid +
        '&channel_did=' +
        channelDID +
        '&parent_queue_uid=' +
        queueToCloneInto +
        '&index=' +
        indexToCloneInto
    );
  } catch (error) {
    console.log(error);
  }
}

function get_master_queue(q) {
  let search = q;
  while (deluge.items[search.pdid].type === 'queue') {
    search = deluge.items[search.pdid];
  }
  return search;
}
async function moved_in_queue(ev, queue) {
  if (state.cueTakeUI.sceneDropped) {
    // This intercepts any drags that end up in the cue drop zone and stops them from being moved in the queue.
    state.cueTakeUI.sceneDropped = false;
    resetChannels();
    return false;
  }

  if (state.cloneScene) {
    state.cloneScene = false;
    if (ev.moved?.newIndex !== undefined) {
      await cloneScene(state.selecteds, ev.moved.newIndex);
    }
    if (ev.added?.newIndex !== undefined) {
      await cloneScene(ev.added.element.did, ev.added.newIndex, queue?.did);
    }
    return false;
  }

  if (state.cloneQueue) {
    if (ev.added) {
      state.cloneQueueTarget = {
        did: queue.did,
        index: ev.added.newIndex,
      };
    }
    return false;
  }

  function resetChannels() {
    deluge.channels = state.channels_cache;
    state.channels_cache = {};
  }

  var type = false;
  if (ev.moved) {
    type = 'moved';
  } else if (ev.added) {
    type = 'added';
  }
  if (type) {
    $http(
      'PUT',
      '/dynamic_engine/dynamic_engine_move_item?drop_to=' +
        queue.did +
        '&dropping_item=' +
        ev[type].element.did +
        '&dropping_item_index=' +
        ev[type].newIndex
    ).then(() => {
      state.selectedq = undefined;
      emit('clear_mini');
      //this.$forceUpdate();
    });
  }
}

function handleClick() {
  // If you click the handle then the dropzone will show, this is not desired behaviour. This function aims to reset this, if it's just a click.
  state.cueTakeUI.sceneDragActive = false;
  state.cueTakeUI.sceneDraggedDID = undefined;
  state.cueTakeUI.sceneDropped = false;
}
const sceneDragStarted = new CustomEvent('sceneDragStarted', {
  detail: {
    message: 'This is fired when scene drag has started',
  },
  bubbles: true,
  cancelable: true,
});

const sceneDragEnded = new CustomEvent('sceneDragEnded', {
  detail: {
    message: 'This is fired when scene drag has stopped',
    someData: 'some data',
  },
  bubbles: true,
  cancelable: true,
});

document.addEventListener('dragstart', function (event) {
  // This is used to inject data to Cue a Scene :)
  // Using this as vue-draggable does some funny stuff, and doesn't pass the original event...

  // vue-draggable is old and uses srcElement and adds __draggable_context*shrug*
  const data = event.srcElement.__draggable_context;

  // NOTE: setData converts the string to LOWERCASE.
  // If you set this to 'HELLO', and try and get 'HELLO' it will fail.
  // Use lowercase for all dataTransfer types.

  if (data.element.type === 'scene') {
    event.dataTransfer.setData('scenedata', JSON.stringify(data));
    event.target.dispatchEvent(sceneDragStarted);
  }

  // dynamic_engine_move_item
  //http://localhost:5173/dev/dynamic_engine/dynamic_engine_move_item?drop_to=160&dropping_item=196&dropping_item_index=4
  if (data.element.type === 'queue') {
    event.dataTransfer.setData('queuedata', JSON.stringify(data));
    const dragParent = document.getElementById('drag-parent-container');
    dragParent.classList.add('drag-parent-container-active');
  }
});

document.addEventListener('dragend', async function (event) {
  const data = event.srcElement.__draggable_context;
  if (data.element.type === 'scene') {
    event.target.dispatchEvent(sceneDragEnded);
  }
  if (data.element.type === 'queue') {
    const dragParent = document.getElementById('drag-parent-container');
    dragParent.classList.remove('drag-parent-container-active');
  }
});

function start_scene_drag(event, parent_Q) {
  state.channels_cache = JSON.parse(JSON.stringify(deluge.channels));
  const index = event.oldIndex;
  // const dragParent = document.getElementById('drag-parent-container');
  // dragParent.classList.add('drag-parent-container-active');
  if (deluge.items[parent_Q.items[index].did].scene_name) {
    if (ctrl_down.value) {
      state.cloneScene = true;
    }

    state.selectedq = undefined;
    state.q_is_not_draggable = true;
    state.selecteds = parent_Q.items[index].did;
    state.cueTakeUI.sceneDragActive = true;
    state.cueTakeUI.sceneDraggedDID = state.selecteds;
    state.cueTakeUI.sceneDropped = false;
  } else {
    if (!state.selectedq) {
      state.selectedq = parent_Q.items[index];
      if (ctrl_down.value) {
        state.cloneQueue = true;
      }
    }
    state.q_is_not_draggable = false;
  }
}

async function end_scene_drag(ev) {
  if (state.cloneQueue) {
    // Edgecase: if user clones to the right with no queues available to the right, will still clone (moved_in_channel does not fire)
    await cloneQueue(props.channel_did, state.selectedq.did, ev.newIndex);
  }

  state.cloneScene = false;
  state.cloneQueue = false;

  state.selectedq = undefined;
  state.q_is_not_draggable = false;
  state.cueTakeUI.sceneDragActive = false;
  state.cueTakeUI.sceneDraggedDID = null;
  const dragParent = document.getElementById('drag-parent-container');
  dragParent.classList.remove('drag-parent-container-active');
  emit('clear_mini');
}
function scene_move(evt) {
  state.qind = evt.draggedContext.futureIndex;
  if (state.selectedq) {
    state.selectedq['mini'] = true;
  }
  return true;
}
function OpenQueueModal(queue, tab_select) {
  tab.value = tab_select;
  current_queue.value = queue;
  current_queue.value_did = queue.did;
  if (queue.did) {
    new_queue_dialog.value = true;
  }
}
function OpenQueue(q, nq) {
  emit('openqueue', { q: q, nq: nq });
}

function OpenSceneModal(scene, tab_index) {
  tab.value = tab_index;
  edit_scene_dialog.value = true;
  current_scene.value = scene;
}
</script>
<style>
.draggablearea {
  overflow-y: auto;
  overflow-x: hidden;
  display: block;
  height: 100%;
  flex-direction: column;
  padding-left: 5px;
  width: 264px;
}

.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}

.drag-parent-container {
  transition: 0.2s;
  background-color: var(--dragArea);

  border-radius: 10px;
  /* padding: 12px; */
}

.drag-parent-container-active {
  background-color: var(--v-background-drag-drop) !important;
  /* background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23069AA8FF' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e"); */
  background-image:
    repeating-linear-gradient(
      0deg,
      var(--primary-color),
      var(--primary-color) 10px,
      transparent 10px,
      transparent 20px
    ),
    repeating-linear-gradient(
      90deg,
      var(--primary-color),
      var(--primary-color) 10px,
      transparent 10px,
      transparent 20px
    ),
    repeating-linear-gradient(
      180deg,
      var(--primary-color),
      var(--primary-color) 10px,
      transparent 10px,
      transparent 20px
    ),
    repeating-linear-gradient(
      270deg,
      var(--primary-color),
      var(--primary-color) 10px,
      transparent 10px,
      transparent 20px
    );
  background-size:
    3px calc(100% + 20px),
    calc(100% + 20px) 3px,
    3px calc(100% + 20px),
    calc(100% + 20px) 3px;
  border-radius: 10px;
  animation: boxBorderAnimation 1s infinite linear;
  padding: 20px !important;
}

@keyframes boxBorderAnimation {
  from {
    background-position:
      0 0,
      -20px 0,
      100% -20px,
      0 100%;
  }
  to {
    background-position:
      0 -20px,
      0 0,
      100% 0,
      -20px 100%;
  }
}
</style>
